import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import { fromBankProofsActions } from '../actions';
import { IBankProof } from '../models/bank-proof.model';

export const bankProofFeatureKey = 'getBankProofs';

export interface CurrentBankProofState {
  currentBankProofResponse: IBankProof;
  currentBankProofFailure: IGenericError<ErrorResponse>;
}

export const initialState: CurrentBankProofState = {
  currentBankProofResponse: undefined,
  currentBankProofFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromBankProofsActions.loadBankProofs, (state, action) => ({
    ...state
  })),
  on(fromBankProofsActions.loadBankProofsSuccess, (state, action) => ({
    ...state,
    currentBankProofResponse: action.response
  })),
  on(fromBankProofsActions.loadBankProofsFailure, (state, action) => ({
    ...state,
    currentBankProofFailure: action.error
  }))
);

export const getCurrentBankProofResponse = (state: CurrentBankProofState) => {
  return state.currentBankProofResponse;
};
export const getCurrentBankProofFailure = (state: CurrentBankProofState) => state.currentBankProofFailure;
